import Box from '@mui/material/Box'
import styled from 'styled-components'

export const SyncAlertsRoot = styled(Box)`
  display: flex;
  flex-direction: column;
`
